<div fxLayout="row" *ngIf="element">
  <form fxFlex="100">
    <mat-form-field fxFlex="100" appearance="standard">
      <mat-label *ngIf="label">{{ 'assignedto' | translate }}</mat-label>
      <mat-select [formControl]="assign">

        <!-- Current value -->
        <mat-select-trigger>
          <span *ngIf="!hasUser(); else user">
            {{ 'notassigned' | translate }}
          </span>
          <ng-template #user>
            <!-- <sg2-user-icon [user]="element.assignedToUserId"></sg2-user-icon> -->
            <span class="value">{{ getUser().fullName }}</span>
          </ng-template>
        </mat-select-trigger>

        <!-- Dropdown -->
        <mat-option [value]="-1" (click)="setUser(-1)">
          <span class="not-assigned">{{ 'notassigned' | translate }}</span>
        </mat-option>
        <mat-option *ngFor="let user of userService.user$ | async" [value]="user._id" (click)="setUser(user._id)">
          <sg2-user-icon [user]="user"></sg2-user-icon>
          {{ user.fullName }}
        </mat-option>

      </mat-select>
    </mat-form-field>
  </form>      
</div>
